import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import { fetchAPI, fetchSEO } from '../../lib/blog/api'
import Seo from '../../components/blog/Seo'
import BlogCard from '../../components/blog/BlogCard'
import SubscribeViaEmailModal from '../../components/SubscribeViaEmailModal'
import CtaButton from '../../components/landing/elements/CtaButton'

const Articles = ({ articles }) => {
  return (
    <div
      className='mb-2 d-flex flex-column px-0 px-md-5 gap-2'
    >
      {articles.map((article, index) => {
        return (
          <BlogCard
            key={`article_${article.attributes.slug}_${index}`}
            article={article}
            path={'blog'}
          />
        )
      })}
    </div>
  )
}

const EmptyState = ({ error }) => {
  return (
    <Row className='py-2 py-lg-5'>
      <Col
        xs={12}
        className='text-center'
      >
        <div className='fs-3'>
          {error
            ? 'Under maintenance 🛠️'
            : 'No articles added yet 🫥'
          }
        </div>

        <div className={'my-5 bg-light br-3'}>
          <Row className='d-flex justify-content-center '>
            <Col xs={12} md={11} xl={9}>
              <div className='p-3 p-md-4 p-lg-5'>
                <div className='fs-3 mb-4'>
                  But we have something even better —
                </div>
                <div className="d-flex justify-content-center">
                  <div style={{ maxWidth: 400 }}>
                    <CtaButton/>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  )
}

const Blog = ({ articles, error, seo }) => {
  return (
    <>
      <Seo seo={seo} />

      <Row className='mt-3'>
        <Col
          xs={12}
          xl={{ span: 8, offset: 2 }}
        >
          <h1 className='text-center fw-semibold mb-5'>
            Blog
          </h1>

          {articles.length
            ? (
            <Articles articles={articles} />
              )
            : (
            <EmptyState error={error} />
              )}
        </Col>
      </Row>

      <SubscribeViaEmailModal />
    </>
  )
}

export async function getStaticProps () {
  let articles = []
  let backendError = false
  const seo = await fetchSEO('blog')
  const articlesRes = await fetchAPI('/blogs', { 'sort[0]': 'createdAt:desc' })
  if (articlesRes) {
    articles = articlesRes.data ?? []
  } else {
    backendError = true
  }

  return {
    props: {
      articles,
      seo,
      error: backendError
    },
    revalidate: 60 * 60 * 24
  }
}

export default Blog
